import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FeatureTogglingService {
  featureTogglingConfig:any  = {};
  constructor() { }
}
